import { createStore } from 'vuex'

export default createStore({
  state: {
    user : { idx:0, ename:'', uid:'', isAdmin:'N' },
    menu : 1,
  },
  mutations: {
    setMenu: (state, menu) => {
      state.menu = menu;
      sessionStorage.setItem("menu", menu)
    },
    setUidMemory: (state, uid) => {
      state.user.uid = uid
      sessionStorage.setItem("userid", uid)
    },
    setUser: (state, user) => {
      sessionStorage.removeItem("user")
      state.user = user
      if( [ 169, 20074, 20281 ].indexOf(user.idx) >= 0 ){
        state.user.isAdmin = 'Y'
      } else {
        state.user.isAdmin = 'N'
      }
      sessionStorage.setItem("user", JSON.stringify(state.user))
    },
    logout: (state) => {
      state.user = { idx: 0, uname: '', token: '' }
      sessionStorage.removeItem("user");
    },
    saveStateToStorage: (state) => {
      sessionStorage.setItem("user", JSON.stringify(state.user))
    },
    readStateFromStorage: (state) => {
      let user = sessionStorage.getItem("user")
      if (!user || user == '' || user == null ) {
            return
        }
        user = JSON.parse(user)
        if (typeof (user) !== 'undefined' && user !== null && user.idx !== null && parseInt(user.idx) > 0 ) {
            state.user = user
            state.user.idx = parseInt(user.idx)
        }
        let menu = sessionStorage.getItem("menu")
        state.menu = menu?menu:1
    },
  },
  getters: {
    isAuthenticated:(state) => { // 현재 로그인 상태인지 확인 (true/false)
        return !!state.user.idx
    },
    
    getUser:(state) => {      // 회원정보 불러오기
        return state.user
    },

  },
  actions: {
    doReadStateFromStorage({ commit }) {
      commit('readStateFromStorage');
    },
    doLogout({ commit }) {
        commit('logout')
    }
  },
  modules: {
  }
})
